module.exports = __webpack_public_path__ + "img/workorderlist2.5a304903.png";